
import React, { Component } from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';
import { SemiTrailerForm } from './Form';


export default class SemiTrailerAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новый полуприцеп';
  }

  onDetail = () => {
    this.props.history.push(`/semi_trailer`);
  };

  render() {
    return (
      <FormProvider
        url={'fleet/trailer'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Полуприцеп добавлен'}
        item={{
          department: this.context.data.department_active,
          is_active: true
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание полуприцепа'}
                backUrl={'/semi_trailer'}
              />

              <Layout.ContentSimple>
                <SemiTrailerForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать полуприцеп
                  </YellowButton>
                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
